import { render, staticRenderFns } from "./advertisements.vue?vue&type=template&id=1b017242&scoped=true&"
import script from "./advertisements.vue?vue&type=script&lang=js&"
export * from "./advertisements.vue?vue&type=script&lang=js&"
import style0 from "./advertisements.vue?vue&type=style&index=0&id=1b017242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b017242",
  null
  
)

export default component.exports